import { FormikProps } from 'formik';
import { Promotion } from '@/@type/promotion';
import { Checkbox, FormControl, FormControlLabel, Typography } from '@mui/material';
import { type SxProps, type Theme } from '@mui/material/styles';
import { Label } from '../styles';
import { useTranslation } from 'react-i18next';
import { SyntheticEvent } from 'react';
import { PromotionType } from '@/__generated__/types';

interface promoCustomerSegmentProps {
  formik: FormikProps<Promotion>;
  sx?: SxProps<Theme>;
}
export const PromoCustomerSegment: React.FC<promoCustomerSegmentProps> = (
  props: promoCustomerSegmentProps
) => {
  const { formik, sx = {} } = props;
  const { isSignUpPromotion, type, isLoyalty } = formik.values;
  const { t } = useTranslation();
  const defaultFormControlStyles: SxProps<Theme> = [{ width: '100%' }, ...(Array.isArray(sx) ? sx : [sx])];

  const handleIsSignUpPromotionOnChange = (
    event: SyntheticEvent<Element, Event>,
    checked: boolean
  ): void => {
    formik.setFieldValue('isSignUpPromotion', checked);
  };

  const isSignUpPromotionDisabled = (): boolean => {
    if (!type) {
      return true;
    }
    if (isLoyalty) {
      return true;
    }
    if (
      type === PromotionType.BuynGetFree ||
      type === PromotionType.Percentage ||
      type === PromotionType.Spend
    ) {
      return false;
    }
    return true;
  };

  return (
    <>
      <FormControl sx={defaultFormControlStyles}>
        <Label>{t('Customer Segment')}</Label>
        <FormControlLabel
          value={isSignUpPromotion}
          checked={isSignUpPromotion}
          onChange={handleIsSignUpPromotionOnChange}
          control={<Checkbox />}
          label={<Typography variant="body1">New customer sign up</Typography>}
          labelPlacement="end"
          disabled={isSignUpPromotionDisabled()}
        />
        <FormControlLabel
          disabled={true}
          control={<Checkbox />}
          label={<Typography variant="body1">Returning customer</Typography>}
          labelPlacement="end"
        />
      </FormControl>
    </>
  );
};
